import { useEffect, useRef, useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { copyTextToClipboard } from '@/lib/clipboard'

export function ReferralCopyField({ label, value }: { label: string; value: string }) {
	const [isCopied, setIsCopied] = useState(false)
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current)
			}
		}
	}, [])

	const handleCopy = () => {
		if (!value) {
			return
		}

		void copyTextToClipboard(value).then((copied) => {
			if (!copied) {
				return
			}

			setIsCopied(true)

			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current)
			}

			timeoutRef.current = setTimeout(() => {
				setIsCopied(false)
			}, 1400)
		})
	}

	return (
		<div className='flex min-w-0 flex-1 items-center gap-3 px-4 py-3'>
			<div className='min-w-0 flex-1'>
				<p className='text-xs font-medium tracking-[-0.18px] text-muted-foreground'>{label}</p>
				<p className='mt-1 truncate text-sm font-semibold tracking-[-0.21px] text-foreground sm:text-base'>{value || '-'}</p>
			</div>
			<button
				type='button'
				onClick={handleCopy}
				disabled={!value}
				className='flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-foreground transition-opacity hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-40'
				aria-label={`Copy ${label}`}
			>
				{isCopied ? <Check className='h-5 w-5 text-primary' /> : <Copy className='h-5 w-5' />}
			</button>
		</div>
	)
}
